"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Services = void 0;
const api_1 = require("./api");
const backend_1 = __importDefault(require("./backend"));
const filtering_1 = require("./filtering");
const http_1 = __importDefault(require("./http"));
const object_1 = __importDefault(require("./object"));
const log_1 = __importDefault(require("./log"));
const title_1 = require("./title");
const form_tools_service_1 = require("./form-tools.service");
const vehicle_export_service_1 = __importDefault(require("./export/vehicle-export.service"));
const dom_1 = require("./dom");
exports.Services = [
    http_1.default,
    backend_1.default,
    api_1.ApiService,
    filtering_1.FilteringService,
    object_1.default,
    log_1.default,
    title_1.TitleService,
    form_tools_service_1.FormToolsService,
    vehicle_export_service_1.default,
    dom_1.DomService,
];
